import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteComposer, getComposers } from '../../store/actions/composer/composer.action';
import ComposersList from '../../components/Composers/Composers';
import PageLoader from '../../components/Common/PageLoader';

const ComposersContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const isCreating = useSelector((state) => state.composer.isCreating);
  const composers = useSelector((state) => state.composer.list);
  const isFetching = useSelector((state) => state.composer.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const composerCategory = categories.find((category) => category.link === 'composers');
      if (composerCategory) {
        setMode(composerCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Composer category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete composer
  const handleDeleteComposer = useCallback((composer) => {
    dispatch(deleteComposer(composer));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getComposers());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare composer info object
  const composerInfo = {
    deleteComposer: handleDeleteComposer,
    composers
  };

  return (
    <section>
      <ComposersList mode={mode} composerInfo={composerInfo} />
    </section>
  );
};

export default ComposersContainer;
